<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['update:modelValue', 'update:focused']);
const { t } = useI18n();
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref([]);
const types = [
    {
        title: t('Alert'),
        value: 'alert'
    },
    {
        title: t('Consolidated'),
        value: 'consolidated'
    },
    {
        title: t('Customer'),
        value: 'customer'
    },
    {
        title: t('Delivery List'),
        value: 'deliverylist'
    },
    {
        title: t('Invoice'),
        value: 'invoice'
    },
    {
        title: t('Loadunit'),
        value: 'loadunit'
    },
    {
        title: t('Multipayment'),
        value: 'multipayment'
    },
    {
        title: t('Package'),
        value: 'package'
    },
    {
        title: t('Payment'),
        value: 'payment'
    },
    {
        title: t('Pickup'),
        value: 'pickup' 
    },
    {
        title: t('PO Box'),
        value: 'pobox'
    },
    {
        title: t('Repacking Request'),
        value: 'repackrequest'
    },
    {
        title: t('Route'),
        value: 'route'
    },
    {
        title: t('Routes Pickup'),
        value: 'listpickup'
    },
    {
        title: t('Shipment'),
        value: 'shipment'
    },
    {
        title: t('Shipping Request'),
        value: 'shippingrequest'
    },
    {
        title: t('Warehouse'),
        value: 'warehouse'
    }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="types"
        :label="hideLabel ? '' : $t('Correlative Type')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
